<template>
  <div>
    <div class="row columns">
      <div class="large-12 columns">
        <div class="note text-left">Cette partie permet d'ajouter ou supprimer des Xp pour le joueur</div>
        <div class="note text-left">Pratique pour gérer les règles cheulous de BB2020</div>
      </div>
    </div>
    <br>
    <div class="row columns">
      <div class="large-6 large-centered">
        <div class="row columns">
          <div class="large-6 columns">
            <h6>Saisir le nombre de Xp à ajouter</h6>
          </div>
          <div class="large-6 columns">
            <span><input type="number" min="0" step="1"  v-model="free_xp"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'free-xp-customizer',
    props: {
      'detailedPlayer': {}
    },
    data () {
      return {
        free_xp: 0
      }
    },
    methods: {
      isUsed: function () {
        return +this.free_xp !== 0 && this.free_xp !== ''
      }
    }
  }
</script>

<style scoped>
thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

tbody.large-font tr td{
    padding: 0.3rem 0.2rem;
    text-align: center;
    font-size:1.1rem;
}
tr td input, tr td select{
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-size:0.7rem;
    margin: 0rem;
}

.large-font {
  font-size: 1.1rem
}
.button-column {
  text-align: right;
}
.note {
  font-size: 0.8rem;
  font-weight: 200;
}
.stat {
  font-weight: 300;
}
.alert {
  color:#E7505A;
}
button.alert {
  color:#FFFFFF;
}
</style>



// WEBPACK FOOTER //
// free-xp-customizer.vue?33ce5faf